import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Asegurate de importar los logos correctamente
import logoAna from "../../assets/img/logoanaseguros.png";
import logoAxa from "../../assets/img/logo-axa.png";
import logoChubb from "../../assets/img/Chubb-logo.png";
import logoGnp from "../../assets/img/GNP_Seguros_logo.svg.png";
import logoGmx from "../../assets/img/Logogmx.png";
import logoGeneral from "../../assets/img/Seguro-general.png";
import logoQuialitas from "../../assets/img/cropped-cropped-IogotipoQualitas-1.png";
import logoSura from "../../assets/img/LOGO-SURA.png";

const Socios = () => {
  return (
    <section className="socios-section">
      <Container>
        <h2 className="socios-title text-center">Socios comerciales</h2>
        <Row className="justify-content-center gy-4">
          <Col xs={6} md={2} className="text-center">
            <img src={logoGeneral} alt="General de Salud" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoAxa} alt="AXA" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoGmx} alt="GMX" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoQuialitas} alt="Qualitas" className="socios-logo" />
          </Col>
        </Row>
        <Row className="justify-content-center gy-4 mt-4">
          <Col xs={6} md={2} className="text-center">
            <img src={logoAna} alt="ANA" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoGnp} alt="GNP" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoSura} alt="Sura" className="socios-logo" />
          </Col>
          <Col xs={6} md={2} className="text-center">
            <img src={logoChubb} alt="Chubb" className="socios-logo" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Socios;
